import computed from './computed'
import methods from './methods'

export default {
  computed,
  methods
}



// WEBPACK FOOTER //
// ./src/layout/headers/menu/config/resources/index.js